(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stamp-personalisation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stamp-personalisation')) {
    customElements.define('stamp-personalisation', class extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;
        this.fileInput = this.querySelector('[data-stamp-file]');
        this.textInput = this.querySelector('[data-stamp-text]');
        this.preview = this.querySelector('[data-stamp-preview]');
        this.image = this.querySelector('[data-stamp-image]');
        this.error = this.querySelector('[data-stamp-error]');
        this.status = this.querySelector('[data-stamp-status]');
        this.form = this.closest('form');
        this.fileInput.addEventListener('change', () => this.previewFile());
        this.textInput.addEventListener('input', () => this.showError(''));
        this.querySelector('[data-stamp-change]').addEventListener('click', () => this.fileInput.click());
        this.querySelector('[data-stamp-remove]').addEventListener('click', () => {
          this.fileInput.value = '';
          this.clearPreview();
          this.showError('');
          this.fileInput.focus();
        });
        this.submitHandler = (event) => {
          if (!this.validate()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        };
        this.form.addEventListener('submit', this.submitHandler, true);
        this.formDataHandler = (event) => {
          for (const name of ['Image', 'Engraving text', 'Design notes']) {
            const key = `properties[${name}]`;
            const value = event.formData.get(key);
            if (typeof value === 'string') {
              if (value.trim()) event.formData.set(key, value.trim());
              else event.formData.delete(key);
            } else if (value instanceof File && !value.size) event.formData.delete(key);
          }
        };
        this.form.addEventListener('formdata', this.formDataHandler);
      }
      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.submitHandler, true);
        this.form?.removeEventListener('formdata', this.formDataHandler);
        if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
        this.initialised = false;
      }
      showError(message) {
        this.error.textContent = message;
        this.error.hidden = !message;
      }
      clearPreview() {
        if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = null;
        this.preview.hidden = true;
        this.image.removeAttribute('src');
        this.status.textContent = '';
      }
      fileError(file) {
        if (!file) return '';
        if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) return this.dataset.typeMessage;
        if (file.size > 10 * 1024 * 1024 || file.size === 0) return this.dataset.sizeMessage;
        return '';
      }
      previewFile() {
        this.clearPreview();
        const file = this.fileInput.files[0];
        const error = this.fileError(file);
        this.showError(error);
        if (error) { this.fileInput.value = ''; return; }
        if (!file) return;
        const url = URL.createObjectURL(file);
        this.previewUrl = url;
        this.image.onload = () => {
          if (this.previewUrl !== url) return;
          this.preview.hidden = false;
          this.status.textContent = this.dataset.selectedMessage;
        };
        this.image.onerror = () => {
          if (this.previewUrl !== url) return;
          this.fileInput.value = '';
          this.clearPreview();
          this.showError(this.dataset.imageMessage);
        };
        this.querySelector('[data-stamp-filename]').textContent = file.name;
        this.image.src = url;
      }
      validate() {
        const file = this.fileInput.files[0];
        const error = this.fileError(file) || (!file && !this.textInput.value.trim() ? this.dataset.requiredMessage : '');
        this.showError(error);
        if (error) {
          (file ? this.fileInput : this.textInput).focus();
          return false;
        }
        return true;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
